
module.exports = 
function fixRange(opts) {
  var reverse = opts.reverse
  var end     = opts.end
  var start   = opts.start

  var range = [start, end]
  if(start != null && end != null)
    range.sort()
  if(reverse)
    range = range.reverse()

  opts.start   = range[0]
  opts.end     = range[1]
  return opts
}




//////////////////
// WEBPACK FOOTER
// ./node_modules/level-fix-range/index.js
// module id = 440
// module chunks = 0